module.exports = __webpack_public_path__ + "static/media/AI.1d1323bb.svg";